class StickyHeader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.header = document.querySelector("sticky-header").parentElement;
        this.menu = document.querySelector(
            "sticky-header .header__inline-menu"
        );
        this.headerIcons = document.querySelector(
            "sticky-header .header__icons"
        );
        this.predictiveSearch = document.querySelector("predictive-search");

        this.headerBounds = {};
        this.currentScrollTop = 0;
        this.scrollThreshold = parseInt(this.dataset.scrollThreshold) || 100;

        this.onScrollHandler = {
            scroll: this.onScroll.bind(this),
            resize: this.onResize.bind(this),
        };

        window.addEventListener("scroll", this.onScrollHandler.scroll, false);
        window.addEventListener("resize", this.onScrollHandler.resize, false);

        this.createObserver();
    }

    disconnectedCallback() {
        window.removeEventListener("scroll", this.onScrollHandler.scroll);
        window.removeEventListener("resize", this.onScrollHandler.resize);
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
    }

    onResize() {
        return window.innerWidth;
    }

    onScroll() {
        const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;

        // Calculate the height of everything above the nav menu
        let collapseOffset =
                this.header?.offsetHeight - this.menu?.offsetHeight - 13,
            collapseOffsetMobile =
                this.header?.offsetHeight - this.headerIcons?.offsetHeight - 24;

        if (this.onResize() > 980 && this.menuHeight < 60)
            collapseOffset = collapseOffsetMobile;

        // At the top of the page (within threshold): show full header
        if (scrollTop <= this.scrollThreshold) {
            this.header.style.top = "0";
            this.reset();
        } else {
            // Any scroll position beyond the top: always collapse
            if (this.predictiveSearch?.hasAttribute("open")) return;

            const offset = this.onResize() > 980 ? collapseOffset : collapseOffsetMobile;
            this.header.style.top = offset > 0 ? "-" + offset + "px" : "0";
            this.applySticky();
        }

        this.currentScrollTop = scrollTop;
    }

    applySticky() {
        this.header.classList.add("section-header-sticky");
        this.header.classList.remove("sticky-animation");
    }

    reset() {
        this.header.classList.add("sticky-animation");
        this.header.classList.remove("section-header-sticky");
        this.closeMenuDisclosure();
        this.closeSearchModal();
    }

    closeMenuDisclosure() {
        this.disclosures =
            this.disclosures ||
            this.header.querySelectorAll("details-disclosure");
        this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
        this.searchModal =
            this.searchModal || this.header.querySelector("details-modal");
        this.searchModal && this.searchModal.close(false);
    }
}

customElements.define("sticky-header", StickyHeader);
